import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => prop !== 'colorScheme',
})<{ colorScheme: 'light' | 'dark' }>(({ colorScheme }) => ({
    '& label': {
        color: colorScheme === 'dark' ? '#383B40' : '#000000',
    },

    '& label.Mui-focused': {
        color: '#40a7e3',
    },

    '& label.Mui-error': {
        color: '#EF3340',
    },

    '& .MuiMenu-paper': {
        width: 94,
        minWidth: 94,
        height: 308,
        left: 28,
        backgroundColor: colorScheme === 'dark' ? '#27292D' : '#FFFFFF',
        color: colorScheme === 'dark' ? '#FFFFFF' : '#000000',
    },

    '& .MuiList-root': {
        padding: '5px 6px',
    },

    '& .Mui-selected': {
        backgroundColor: '#40a7e3',
        color: '#FFFFFF',
    },
}));
